import { render, staticRenderFns } from "./MainCategory.vue?vue&type=template&id=054db1bf&scoped=true"
import script from "./MainCategory.vue?vue&type=script&lang=js"
export * from "./MainCategory.vue?vue&type=script&lang=js"
import style0 from "./MainCategory.vue?vue&type=style&index=0&id=054db1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054db1bf",
  null
  
)

export default component.exports